import { useMemo } from "react";
import { resolveCssVar } from "utils/cssVar";
import { useDonutChartOptions } from "utils/donutTooltip";
import { toPercent } from "utils/toPercent";

import { colorFor } from "./constants";

export const useArchivedOpportunitiesByReasonChart = (reasons, totalArchivedCount) => {
  const formatTooltipBody = (item) => {
    const count = item.parsed ?? 0;
    return `${count} archived · ${toPercent(count, totalArchivedCount)}%`;
  };

  const { chartOptions, tooltipRef, titleRef, bodyRef } = useDonutChartOptions({
    formatBody: formatTooltipBody,
  });

  const chartData = useMemo(
    () => ({
      labels: reasons.map((reason) => reason.statusName),
      datasets: [
        {
          data: reasons.map((reason) => reason.count),
          backgroundColor: reasons.map((reason, index) => resolveCssVar(colorFor(reason, index))),
          borderWidth: 0,
          hoverOffset: 0,
          hoverBorderWidth: 0,
        },
      ],
    }),
    [reasons]
  );

  return { chartData, chartOptions, tooltipRef, titleRef, bodyRef };
};
